import { Text } from '@/ui/typography';
import { COLORS } from '@/utils/static';
import { getFontSize } from '../utils';
import { useTranslation } from 'react-i18next';

export const NameColumn = ({ name, windowWidth }) => {
  const { t } = useTranslation();
  const fontSize = getFontSize(windowWidth);

  return (
    <Text $fontSize={fontSize} $color={COLORS.blueAntd}>
      {t(name)}
    </Text>
  );
};

